<script>
	import { taskTypeHelper } from "src/utils/options";
	import SidePopup from "../../../components/SidePopup/SidePopup.svelte";
	import { Col, Row } from "sveltestrap";
	import { imageLightbox } from "src/store/store";
	import Lightbox from "../../../components/Lightbox/Lightbox.svelte";

	export let task;
	export let toggleDetails;

	let modalOpen = false;
	let imgIndex = 0;

	function handleOpenImage(i) {
		imageLightbox.set([]);
		imageLightbox.set(["/image.png", "/image.png"]);
		imgIndex = Number(i);
		modalOpen = !modalOpen;
	}
</script>

{#if modalOpen}
	<Lightbox on:click={() => (modalOpen = false)} />
{/if}
<SidePopup {toggleDetails}>
	<div class="popup-item">
		<h5>T145 - {taskTypeHelper(task.taskType)}</h5>
	</div>
	<div class="popup-mid popup-item">
		<Row class="popup-item">
			<Col xs={6}>
				<div class="category-name">Task Status</div>
				{#if task.status === true}
					<div class="status-bar status-bar-1">Active</div>
				{:else}
					<div class="status-bar status-bar-2">Inactive</div>
				{/if}
			</Col>
			<Col xs={6}>
				<div class="category-name">Priority</div>
				<div>High</div>
			</Col>
		</Row>
		<div class="popup-item">
			<div class="category-name">Planner's Remarks</div>
			<div>Remarks</div>
		</div>
		<div class="popup-item">
			<div class="category-name">
				Operator's Remarks Photos and Videos
			</div>
			<div class="d-flex flex-wrap">
				<img
					class="remark-img"
					src="/image.png"
					alt="remark-report"
					on:click={() => handleOpenImage(0)}
					on:keydown={() => {}}
				/>
				<img
					class="remark-img"
					src="/image.png"
					alt="remark-report"
					on:click={() => handleOpenImage(1)}
					on:keydown={() => {}}
				/>
			</div>
			<div>OPERATORS REMARKS TO BE FILLED</div>
		</div>
	</div>
	<div class="popup-item">
		<Col xs={12}>
			<Row class="popup-header">
				<Col>
					<b>Date</b>
				</Col>
				<Col>
					<b>Description</b>
				</Col>
			</Row>
			<Row class="popup-item">
				<Col>2 October 2024, 11:45am</Col>
				<Col>Status changed from Active to Completed by Fateh.</Col>
			</Row>
			<Row class="popup-item">
				<Col>2 October 2024, 11:45am</Col>
				<Col>Status changed from Active to Completed by Fateh.</Col>
			</Row>
			<Row class="popup-item">
				<Col>2 October 2024, 11:45am</Col>
				<Col>Status changed from Active to Completed by Fateh.</Col>
			</Row>
			<Row class="popup-item">
				<Col>2 October 2024, 11:45am</Col>
				<Col>Status changed from Active to Completed by Fateh.</Col>
			</Row>
			<Row class="popup-item">
				<Col>2 October 2024, 11:45am</Col>
				<Col>Status changed from Active to Completed by Fateh.</Col>
			</Row>
			<Row class="popup-item">
				<Col>2 October 2024, 11:45am</Col>
				<Col>Status changed from Active to Completed by Fateh.</Col>
			</Row>
		</Col>
	</div></SidePopup
>

<style>
	.remark-img {
		width: 86px;
		height: 86px;
		margin-right: 2px;
	}
</style>
